import axios from 'axios'
import { CADASTAR_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarEmpresa (empresa) {
  const url = `${URL}/empresas/cadastrar`;
  return dispatch => axios.post(url, empresa, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTAR_EMPRESA,
        payload: response
      })
  );
}
